import { render, staticRenderFns } from "./TheRingtoneAudio.vue?vue&type=template&id=38e0e278"
import script from "./TheRingtoneAudio.vue?vue&type=script&lang=js"
export * from "./TheRingtoneAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports